import { Drawer, Dropdown, Image, Select, message } from "antd";
import { CaretDownFilled } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getFromLocalStorage } from "../../utils/storageUtil";
import {
  GetClientsList,
  GetProvidersList,
  GetTemplates,
  SendNotification,
} from "../../utils/api";
import LogoImg from "../../assets/logo-high.png";

// import MenuIcon from '../../assets/menu.svg';
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useForm } from "react-hook-form";
// import { ticketValidation } from "../../utils/validations/formValidations";
// import MessageIcon from '../../assets/message.png';

const BroadcastNotification = ({ open, setOpen }) => {
  const [notificationtype, setNotificationtype] = useState("email");
  const [usertype, setUsertype] = useState("client");
  const [filterClient, setFilterClient] = useState("allClients");
  const [filterProvider, setFilterProvider] = useState("allProviders");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [providerOptions, setProviderOptions] = useState([]);
  const [accountsToSend, setAccountsToSend] = useState([]);

  // const { register, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(ticketValidation) });

  const handleCancel = () => {
    setOpen(false);
    setSelectedTemplate(null);
    // reset();
  };

  const handleFilterClientChange = (option) => {
    setFilterClient(option);
  };
  const handleFilterProviderChange = (option) => {
    setFilterProvider(option);
  };

  const handleTypeChange = (type) => {
    setNotificationtype(type);
    setSelectedTemplate(null);
  };

  const handleUserTypeChange = (option) => {
    setUsertype(option);
    setFilterClient("allClients");
    setFilterProvider("allProviders");
    setSelectedTemplate(null);
  };

  const handleSelectTemplate = (id) => {
    const selectedTemplate = templates.find(
      (template) => template.id === Number(id)
    );
    if (selectedTemplate) {
      setSelectedTemplate(selectedTemplate);
    }
  };

  const handleSendNotification = async () => {
    if (
      filterClient === "specificClients" ||
      filterProvider === "specificProviders"
    ) {
      if (accountsToSend.length <= 0) {
        message.destroy();
        return message.error(
          `Please Select ${
            usertype === "provider" ? "Service providers" : "Clients"
          }`
        );
      }
    }
    const data = {
      ...selectedTemplate,
      userType: usertype,
      adminId: getFromLocalStorage("admin")?.id,
      templateId: selectedTemplate?.id,
      userIds: accountsToSend,
      sendTo: accountsToSend.length > 0 ? "multiple" : "all",
    };
    // console.log(data);
    try {
      setLoading(true);
      const resData = await SendNotification(data);
      if (resData?.isSuccess) {
        message.success("Notification broadcasted successfully");
        setUsertype("client");
        setFilterClient("allClients");
        setFilterProvider("allProviders");
        handleCancel();
      } else {
        message.destroy();
        message.error(resData?.error);
      }
    } catch (error) {
      message.error(
        "An error occurred during the process. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const getTemplates = async (params) => {
    try {
      const response = await GetTemplates(params);
      if (response?.isSuccess) {
        setTemplates(response?.items);
      }
    } catch (error) {
      message.error("Error in updating status, Try again later");
    } finally {
    }
  };

  const handleAccountsToSendChange = (value) => {
    setAccountsToSend(value);
  };

  const getClientOptions = async () => {
    try {
      const response = await GetClientsList();
      if (response?.isSuccess) {
        setClientOptions(response?.data);
      }
    } catch (error) {
      message.error("Error, Try again later");
    } finally {
    }
  };

  const getProviderOptions = async () => {
    try {
      const response = await GetProvidersList();
      if (response?.isSuccess) {
        setProviderOptions(response?.data);
      }
    } catch (error) {
      message.error("Error, Try again later");
    } finally {
    }
  };

  useEffect(() => {
    getTemplates(
      `type=${
        notificationtype === "push" ? "notification" : "email"
      }&templateFor=${usertype}`
    );
  }, [usertype, notificationtype]);

  useEffect(() => {
    getClientOptions();
    getProviderOptions();
  }, [open]);

  return (
    <>
      <Drawer
        className="send-email_drawer"
        title="Broadcast Notification"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <div className="w-full bg-primary-300">
          <div className="poppins w-full flex flex-col gap-y-3 pr-6 pl-8 pt-2 pb-6 border-bottom bg-[#fdfafa] border-custom border-[#707070]">
            <div></div>
            {/* Header */}
            <div className="w-full flex flex-col gap-y-4 text-xs font-semibold">
              {/* Notificatiion Type */}
              <div className="flex items-center">
                <span className="w-32 font-medium">Notification Type:</span>
                <div className="text-black-500 flex font-normal items-center gap-x-4">
                  <div className="flex items-center gap-1">
                    <input
                      className="custom-checkbox"
                      type="radio"
                      id="email"
                      name="notificationType"
                      checked={notificationtype === "email"}
                      onChange={() => handleTypeChange("email")}
                      value={notificationtype}
                    />
                    <label for="email">Email</label>
                  </div>
                  <div className="flex items-center gap-1">
                    <input
                      className="custom-checkbox"
                      type="radio"
                      id="push"
                      name="notificationType"
                      checked={notificationtype === "push"}
                      onChange={() => handleTypeChange("push")}
                      value={notificationtype}
                    />
                    <label for="push">Push notification</label>
                  </div>
                </div>
              </div>
              {/* User Type */}
              <div className="flex items-center pt-2">
                <span className="w-20 font-medium">User Type:</span>
                <div className="text-black-500 font-normal flex items-center gap-x-4">
                  <div className="flex items-center gap-1">
                    <input
                      className="custom-checkbox"
                      type="radio"
                      id="clients"
                      name="userType"
                      checked={usertype === "client"}
                      onChange={() => handleUserTypeChange("client")}
                      value={usertype}
                    />
                    <label for="clients">Clients</label>
                  </div>
                  <div className="flex items-center gap-1">
                    <input
                      className="custom-checkbox"
                      type="radio"
                      id="service"
                      name="userType"
                      checked={usertype === "provider"}
                      onChange={() => handleUserTypeChange("provider")}
                      value={usertype}
                    />
                    <label for="service">Service Providers</label>
                  </div>
                </div>
              </div>

              {usertype === "client" ? (
                <div className="flex gap-x-4 items-center">
                  <span className="w-20 font-medium">Filter Clients:</span>
                  {filterClient === "specificClients" ? (
                    <div className="flex w-full items-end justify-between">
                      <Select
                        allowClear
                        mode="multiple"
                        style={{
                          width: "80%",
                        }}
                        placeholder="Please select clients"
                        onChange={handleAccountsToSendChange}
                        // options={clientOptions.map((item) => ({
                        //   label: item.name,
                        //   value: item.id,
                        // }))}
                        filterOption={(input, option) => {
                          const inputText =
                            input && input.toString().toLowerCase();
                          const optionLabel =
                            option.label &&
                            option.label.toString().toLowerCase();
                          return (
                            inputText &&
                            optionLabel &&
                            optionLabel.indexOf(inputText) >= 0
                          );
                        }}
                      >
                        {clientOptions?.length &&
                          clientOptions?.map((foo) => (
                            <Select.Option
                              value={foo.id}
                              key={foo.id}
                              className="last:pb-6"
                            >
                              {foo.name}
                            </Select.Option>
                          ))}
                      </Select>
                      <button onClick={() => setFilterClient("allClients")}>
                        All ?
                      </button>
                    </div>
                  ) : (
                    <Select
                      value={filterClient}
                      onChange={handleFilterClientChange}
                      options={[
                        {
                          value: "allClients",
                          label: "All clients",
                        },
                        {
                          value: "specificClients",
                          label: "Specific clients",
                        },
                      ]}
                    />
                  )}
                </div>
              ) : (
                <div className="flex gap-x-4 items-center">
                  <span className="w-20 font-medium">
                    Filter Service Providers:
                  </span>
                  {filterProvider === "specificProviders" ? (
                    <div className="flex w-full items-end justify-between">
                      <Select
                        allowClear
                        mode="multiple"
                        style={{
                          width: "80%",
                        }}
                        placeholder="Please select providers"
                        onChange={handleAccountsToSendChange}
                        // options={providerOptions.map((item) => ({
                        //   label: item.businessName,
                        //   value: item.id,
                        // }))}
                        filterOption={(input, option) => {
                          const inputText =
                            input && input.toString().toLowerCase();
                          const optionLabel =
                            option.label &&
                            option.label.toString().toLowerCase();
                          return (
                            inputText &&
                            optionLabel &&
                            optionLabel.indexOf(inputText) >= 0
                          );
                        }}
                      >
                        {providerOptions?.length &&
                          providerOptions?.map((foo) => (
                            <Select.Option
                              value={foo.id}
                              key={foo.id}
                              className="last:pb-6"
                            >
                              {foo.businessName}
                            </Select.Option>
                          ))}
                      </Select>
                      <button onClick={() => setFilterProvider("allProviders")}>
                        All ?
                      </button>
                    </div>
                  ) : (
                    <Select
                      value={filterProvider}
                      onChange={handleFilterProviderChange}
                      options={[
                        {
                          value: "allProviders",
                          label: "All service providers",
                        },
                        {
                          value: "specificProviders",
                          label: "Specific service providers",
                        },
                      ]}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end px-6">
          <div className="w-max border border-input-placeholder flex items-center gap-x-2 rounded-lg py-3 px-4 relative mt-4">
            {/* <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="text">Template</label>
          <svg className='flex-shrink-0 ml-1' width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

            <g id="SVGRepo_bgCarrier" stroke-width="0" />

            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

            <g id="SVGRepo_iconCarrier"> <path d="M4 12H20M4 8H20M4 16H12" stroke="#797979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> </g>

          </svg>
          <input readOnly className="w-full outline-none text-[12px] text-input-placeholder" type="text" id="text" placeholder='Select a template' /> */}
            <Dropdown
              menu={{
                items: templates
                  // .filter((template) => {
                  //   return notificationtype === "push"
                  //     ? template.type === "notification"
                  //     : template.type === "email";
                  // })
                  .map((template) => ({
                    key: template.id,
                    label: template.title,
                  })),
                onClick: (e) => handleSelectTemplate(e.key),
              }}
              trigger={["click"]}
              overlayStyle={{ maxHeight: "280px", overflowY: "auto" }}
            >
              <div className="flex gap-x-2 items-center cursor-pointer">
                <span className=" text-xs font-medium">Select a Template</span>
                <CaretDownFilled />
              </div>
            </Dropdown>
          </div>
        </div>

        {selectedTemplate && (
          <div className="mx-8">
            <div className="flex items-center justify-center mt-4">
              {selectedTemplate?.type === "email" ? (
                <Image
                  src={selectedTemplate?.body}
                  alt={selectedTemplate?.title}
                  width="160px"
                />
              ) : (
                <div className="box-shadow p-4 flex flex-col gap-y-2 rounded-2xl">
                  <div className="flex items-center gap-x-1 px-2">
                    <img
                      src={LogoImg}
                      alt="logo-img"
                      className="w-5 h-5 object-contain flex-shrink-0"
                    />
                    <span className="text-sm font-thin">Beauty Spot</span>
                  </div>
                  <div className="px-2 pt-1">
                    <p className="text-sm font-semibold leading-tight mb-1">
                      {selectedTemplate?.title}
                    </p>
                    <div className="w-full">
                      <p className="text-xs">{selectedTemplate?.body}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-6 flex items-center justify-center gap-x-3">
              <span
                className=" bg-white flex-1 text-center text-primary-700 border border-primary-700 text-[10px] px-6 py-3 rounded-lg cursor-pointer"
                onClick={handleCancel}
              >
                Cancel
              </span>
              <button
                disabled={loading}
                onClick={handleSendNotification}
                className="flex-1 text-center bg-primary-700 border border-primary-700 text-white text-[10px] px-6 py-3 rounded-lg cursor-pointer flex items-center justify-center gap-x-2"
              >
                Send
                {loading && <span className="loader"></span>}
              </button>
            </div>
          </div>
        )}
      </Drawer>
    </>
  );
};
export default BroadcastNotification;
